import { p as proxyCustomElement, H, c as createEvent, A as AriaAttr, h } from './p-d7c3b756.js';
import * as _ from 'lodash-es';
import { d as defineCustomElement$1 } from './p-6c17fe8d.js';
import { B as BxfContextMenuConstants } from './p-9e46a58d.js';
import { u as uuidv4 } from './p-2b83a1d1.js';
import { B as BxfDefaultState } from './p-7451d809.js';
import { i as isUsingI18n, B as BxfI18n, t as translateKeys } from './p-01256821.js';
import { K as KeyboardEventKey } from './p-b3de3bce.js';
import { F as FocusTrap, B as BxfPositionConstants } from './p-31d5cbf5.js';
import { F as FocusIndexManager } from './p-8b298ca7.js';
import { O as WindowEventMap, P as eventPath, w as getKeyboardFocusCSS, l as createSelector } from './p-0856cfca.js';
import { g as getParentOverlayContainer } from './p-89fcff47.js';
import { B as BxfOverlayMenuController } from './p-3e4b76ad.js';
import { R as Role } from './p-2c2985b9.js';
import { b as BxfDynamicPositionEnum, e as BxfOverlayTriggerEnum } from './p-7397c455.js';

const bxfContextMenuCss = "@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg)}}@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@-webkit-keyframes spin{0%{transform:translateY(0px)}25%{transform:translateY(-12px)}50%,100%{transform:translateY(0px)}}@keyframes jump{0%{transform:translateY(0px)}25%{transform:translateY(-12px)}50%,100%{transform:translateY(0px)}}button.sc-bxf-context-menu:hover,a.sc-bxf-context-menu:hover,input[type=radio].sc-bxf-context-menu:hover,input[type=checkbox].sc-bxf-context-menu:hover,input[type=radio].sc-bxf-context-menu:checked:hover,input[type=checkbox].sc-bxf-context-menu:checked:hover,svg.sc-bxf-context-menu:hover{cursor:pointer}svg[disabled].sc-bxf-context-menu:hover,button[disabled].sc-bxf-context-menu:hover,label[disabled].sc-bxf-context-menu:hover,input[type=checkbox].sc-bxf-context-menu:disabled:hover,input[type=radio].sc-bxf-context-menu:disabled:hover,input[type=checkbox].sc-bxf-context-menu:checked:disabled:hover,input[type=radio].sc-bxf-context-menu:checked:disabled:hover{cursor:default}.bxf__assistive-text--hidden.sc-bxf-context-menu{position:absolute !important;left:-625rem;top:auto;width:0.0625rem;height:0.0625rem;overflow:hidden}.oneds-blk-heading-display-1.sc-bxf-context-menu{font-size:clamp(2.3675rem, 1.3308rem + 4.6074vw, 5.4775rem);line-height:1.22;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-display-1.sc-bxf-context-menu{line-height:1.21}}@media (min-width: 48rem){.oneds-blk-heading-display-1.sc-bxf-context-menu{line-height:1.2}}@media (min-width: 64rem){.oneds-blk-heading-display-1.sc-bxf-context-menu{line-height:1.18}}@media (min-width: 90rem){.oneds-blk-heading-display-1.sc-bxf-context-menu{line-height:1.16}}.oneds-blk-heading-xxl.sc-bxf-context-menu{font-size:clamp(2.0931rem, 1.3588rem + 3.2639vw, 4.2963rem);line-height:1.22;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-xxl.sc-bxf-context-menu{line-height:1.22}}@media (min-width: 48rem){.oneds-blk-heading-xxl.sc-bxf-context-menu{line-height:1.21}}@media (min-width: 64rem){.oneds-blk-heading-xxl.sc-bxf-context-menu{line-height:1.2}}@media (min-width: 90rem){.oneds-blk-heading-xxl.sc-bxf-context-menu{line-height:1.18}}.oneds-blk-heading-xl.sc-bxf-context-menu{font-size:clamp(1.8506rem, 1.3444rem + 2.25vw, 3.3694rem);line-height:1.23;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-xl.sc-bxf-context-menu{line-height:1.22}}@media (min-width: 48rem){.oneds-blk-heading-xl.sc-bxf-context-menu{line-height:1.22}}@media (min-width: 64rem){.oneds-blk-heading-xl.sc-bxf-context-menu{line-height:1.21}}@media (min-width: 90rem){.oneds-blk-heading-xl.sc-bxf-context-menu{line-height:1.2}}.oneds-blk-heading-l.sc-bxf-context-menu{font-size:clamp(1.6363rem, 1.3008rem + 1.4907vw, 2.6425rem);line-height:1.23;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-l.sc-bxf-context-menu{line-height:1.23}}@media (min-width: 48rem){.oneds-blk-heading-l.sc-bxf-context-menu{line-height:1.23}}@media (min-width: 64rem){.oneds-blk-heading-l.sc-bxf-context-menu{line-height:1.22}}@media (min-width: 90rem){.oneds-blk-heading-l.sc-bxf-context-menu{line-height:1.21}}.oneds-blk-heading-m.sc-bxf-context-menu{font-size:clamp(1.4469rem, 1.2383rem + 0.9269vw, 2.0725rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-m.sc-bxf-context-menu{line-height:1.23}}@media (min-width: 48rem){.oneds-blk-heading-m.sc-bxf-context-menu{line-height:1.23}}@media (min-width: 64rem){.oneds-blk-heading-m.sc-bxf-context-menu{line-height:1.23}}@media (min-width: 90rem){.oneds-blk-heading-m.sc-bxf-context-menu{line-height:1.22}}.oneds-blk-heading-s.sc-bxf-context-menu{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-s.sc-bxf-context-menu{line-height:1.24}}@media (min-width: 48rem){.oneds-blk-heading-s.sc-bxf-context-menu{line-height:1.24}}@media (min-width: 64rem){.oneds-blk-heading-s.sc-bxf-context-menu{line-height:1.24}}@media (min-width: 90rem){.oneds-blk-heading-s.sc-bxf-context-menu{line-height:1.23}}.oneds-blk-heading-xs.sc-bxf-context-menu{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-heading-xxs.sc-bxf-context-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-eyebrow-l.sc-bxf-context-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.27;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-eyebrow-m.sc-bxf-context-menu{font-size:14px;line-height:1.3;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-eyebrow-s.sc-bxf-context-menu{font-size:12px;line-height:1.34;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xl.sc-bxf-context-menu{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.4;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xl-bold.sc-bxf-context-menu{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.4;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xl-italic.sc-bxf-context-menu{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.4;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-xl-link.sc-bxf-context-menu{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.4;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-l.sc-bxf-context-menu{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.45;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-l-bold.sc-bxf-context-menu{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.45;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-l-italic.sc-bxf-context-menu{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.45;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-l-link.sc-bxf-context-menu{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.45;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-m.sc-bxf-context-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-m-bold.sc-bxf-context-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-m-italic.sc-bxf-context-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-m-link.sc-bxf-context-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-m-compact.sc-bxf-context-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-m-compact-bold.sc-bxf-context-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-m-compact-italic.sc-bxf-context-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-m-compact-link.sc-bxf-context-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-s.sc-bxf-context-menu{font-size:14px;line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-s-bold.sc-bxf-context-menu{font-size:14px;line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-s-italic.sc-bxf-context-menu{font-size:14px;line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-s-link.sc-bxf-context-menu{font-size:14px;line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-s-compact.sc-bxf-context-menu{font-size:14px;line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-s-compact-bold.sc-bxf-context-menu{font-size:14px;line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-s-compact-italic.sc-bxf-context-menu{font-size:14px;line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-s-compact-link.sc-bxf-context-menu{font-size:14px;line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-xs.sc-bxf-context-menu{font-size:12px;line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xs-bold.sc-bxf-context-menu{font-size:12px;line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xs-italic.sc-bxf-context-menu{font-size:12px;line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-xs-link.sc-bxf-context-menu{font-size:12px;line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-xs-compact.sc-bxf-context-menu{font-size:12px;line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xs-compact-bold.sc-bxf-context-menu{font-size:12px;line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xs-compact-italic.sc-bxf-context-menu{font-size:12px;line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-xs-compact-link.sc-bxf-context-menu{font-size:12px;line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu a.sc-bxf-context-menu{font-size:clamp(2.0931rem, 1.3588rem + 3.2639vw, 4.2963rem);line-height:1.22;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-m) 0 var(--oneds-space-fluid-m) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.22}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.21}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.2}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.18}}.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu strong.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu em.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h1.sc-bxf-context-menu a.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu a.sc-bxf-context-menu{font-size:clamp(1.8506rem, 1.3444rem + 2.25vw, 3.3694rem);line-height:1.23;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-s) 0 var(--oneds-space-fluid-m) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.22}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.22}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.21}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.2}}.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu strong.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu em.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h2.sc-bxf-context-menu a.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu a.sc-bxf-context-menu{font-size:clamp(1.6363rem, 1.3008rem + 1.4907vw, 2.6425rem);line-height:1.23;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-xs) 0 var(--oneds-space-fluid-s) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.23}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.23}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.22}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.21}}.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu strong.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu em.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h3.sc-bxf-context-menu a.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu a.sc-bxf-context-menu{font-size:clamp(1.4469rem, 1.2383rem + 0.9269vw, 2.0725rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-xxs) 0 var(--oneds-space-fluid-xs) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.23}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.23}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.23}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.22}}.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu strong.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu em.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h4.sc-bxf-context-menu a.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu a.sc-bxf-context-menu{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-xxxs) 0 var(--oneds-space-fluid-xxs) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.24}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.24}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.24}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu a.sc-bxf-context-menu{line-height:1.23}}.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu strong.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu em.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h5.sc-bxf-context-menu a.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-context-menu h6.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h6.sc-bxf-context-menu strong.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h6.sc-bxf-context-menu em.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu h6.sc-bxf-context-menu a.sc-bxf-context-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding-bottom:var(--oneds-space-xxs)}.oneds-richTextEditorOutput.sc-bxf-context-menu h6.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h6.sc-bxf-context-menu strong.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h6.sc-bxf-context-menu em.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible,.oneds-richTextEditorOutput.sc-bxf-context-menu h6.sc-bxf-context-menu a.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-context-menu p.sc-bxf-context-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding-bottom:var(--oneds-space-m)}.oneds-richTextEditorOutput.sc-bxf-context-menu ul.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu ol.sc-bxf-context-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:0 0 var(--oneds-space-m) var(--oneds-space-m);list-style-type:revert}.oneds-richTextEditorOutput.sc-bxf-context-menu ul.sc-bxf-context-menu li.sc-bxf-context-menu:not(:last-child),.oneds-richTextEditorOutput.sc-bxf-context-menu ol.sc-bxf-context-menu li.sc-bxf-context-menu:not(:last-child){padding-bottom:var(--oneds-space-m)}.oneds-richTextEditorOutput.sc-bxf-context-menu strong.sc-bxf-context-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding-bottom:var(--oneds-space-m)}.oneds-richTextEditorOutput.sc-bxf-context-menu em.sc-bxf-context-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic;padding-bottom:var(--oneds-space-m)}.oneds-richTextEditorOutput.sc-bxf-context-menu a.sc-bxf-context-menu{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline;color:var(--oneds-text-default);text-decoration:underline;text-decoration-thickness:2px;text-underline-offset:3px;transition:text-decoration 300ms ease-out}.oneds-richTextEditorOutput.sc-bxf-context-menu .mce-content-body.sc-bxf-context-menu [data-mce-selected=inline-boundary].sc-bxf-context-menu{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-context-menu a.sc-bxf-context-menu:hover,.oneds-richTextEditorOutput.sc-bxf-context-menu a.sc-bxf-context-menu:active{text-decoration:underline;text-decoration-thickness:4px;transition:text-decoration 100ms ease-out}.oneds-richTextEditorOutput.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible{background:var(--oneds-bg-black);color:var(--oneds-text-inverse);text-decoration:none;border:none;outline:none;border-radius:0}.oneds-richTextEditorOutput.oneds-bg-black.sc-bxf-context-menu a.sc-bxf-context-menu{color:var(--oneds-text-inverse)}.oneds-richTextEditorOutput.oneds-bg-black.sc-bxf-context-menu a.sc-bxf-context-menu:focus-visible{background:var(--oneds-bg-white);color:var(--oneds-text-default);text-decoration:none;border:none;outline:none;border-radius:0}.oneds-richTextEditorOutput.sc-bxf-context-menu sub.sc-bxf-context-menu,.oneds-richTextEditorOutput.sc-bxf-context-menu sup.sc-bxf-context-menu{line-height:0}.bxf-context-menu--overlay.sc-bxf-context-menu{width:fit-content}.bxf-context-menu__flyout.sc-bxf-context-menu,.bxf-context-menu__show.sc-bxf-context-menu{width:fit-content;max-height:none !important;min-width:8.75rem;background-color:#ffffff;border:0.0625rem solid #aeaba7;padding:4px 0;margin:0;border-radius:0.125rem;box-shadow:0 0.375rem 12px 0 #d9d6ce}.bxf-context-menu__flyout.bxf__mouse-focus.sc-bxf-context-menu .bxf-context-menu__item.sc-bxf-context-menu:focus,.bxf-context-menu__flyout.bxf-context-menu__flyout.bxf__mouse-focus.sc-bxf-context-menu .bxf-context-menu__item.sc-bxf-context-menu:focus,.bxf-context-menu__show.bxf__mouse-focus.sc-bxf-context-menu .bxf-context-menu__item.sc-bxf-context-menu:focus,.bxf-context-menu__show.bxf-context-menu__flyout.bxf__mouse-focus.sc-bxf-context-menu .bxf-context-menu__item.sc-bxf-context-menu:focus{outline:none}.bxf-context-menu__item-wrapper.sc-bxf-context-menu,.bxf-context-menu__group-separator.sc-bxf-context-menu{list-style:none}.bxf-context-menu__item.sc-bxf-context-menu{overflow:hidden;display:flex;color:#000000;font-size:0.8125rem;line-height:1.8461538462;height:1.5rem;width:100%;padding:0.125rem 0}.bxf-context-menu__item.sc-bxf-context-menu:hover{background-color:#ffb1941A}.bxf-context-menu__item.sc-bxf-context-menu:hover{cursor:pointer}.bxf-context-menu__item.sc-bxf-context-menu:focus{outline:0.0625rem dotted var(--primary-action__color);outline:auto var(--primary-action__color)}.bxf-context-menu__item.bxf__focus--keyboard-only.sc-bxf-context-menu:focus:not(:focus-visible){outline:0}.bxf-context-menu__item--compact.sc-bxf-context-menu{display:flex;color:#000000;font-size:0.8125rem;line-height:1.2307692308;height:1rem;width:100%;padding:0.125rem 0}.bxf-context-menu__item--compact.sc-bxf-context-menu:hover{background-color:#ffb1941A}.bxf-context-menu__item--compact.sc-bxf-context-menu:hover{cursor:pointer}.bxf-context-menu__item--compact.sc-bxf-context-menu:focus{outline:0.0625rem dotted var(--primary-action__color);outline:auto var(--primary-action__color)}.bxf-context-menu__item--compact.bxf__focus--keyboard-only.sc-bxf-context-menu:focus:not(:focus-visible){outline:0}.bxf-context-menu__item.disabled.sc-bxf-context-menu{color:#d9d6ce}.bxf-context-menu__item.disabled.sc-bxf-context-menu:hover{background-color:#ffffff}.bxf-context-menu__item.disabled.sc-bxf-context-menu:hover:focus{outline:none}.bxf-context-menu__item.disabled.sc-bxf-context-menu:hover{cursor:default}.bxf-context-menu__item.alert.sc-bxf-context-menu{color:#c00b28}.bxf-context-menu__item.selected.sc-bxf-context-menu{background-color:#ffb1941A}.bxf-context-menu__item.bottom-border.sc-bxf-context-menu{border-bottom:0.0625rem solid #aeaba7}.bxf-context-menu__group-separator.sc-bxf-context-menu{height:0.0625rem;background-color:#d9d6ce}.bxf-context-menu__lefticon.sc-bxf-context-menu{display:flex;justify-content:center;width:16px;padding:0 8px;pointer-events:none;align-items:center;fill:none;color:#000000}.bxf-context-menu__lefticon-flyout--not-selected.sc-bxf-context-menu{padding-left:12px}.bxf-context-menu__righticon.sc-bxf-context-menu{display:flex;justify-content:center;margin-left:auto;min-width:16px;padding:0 8px;pointer-events:none;align-items:center;color:#000000}.bxf-context-menu__norighticon.sc-bxf-context-menu{padding-right:12px;pointer-events:none}.bxf-contextmenu__inner-label.sc-bxf-context-menu{color:#6b6a67;padding:0 1.9375rem;margin-left:auto}.bxf-context-menu__righticon-flyout.sc-bxf-context-menu{display:flex;justify-content:center;margin-left:auto;min-width:16px;pointer-events:none;align-items:center;color:#6b6a67}.bxf-context-menu__zoom-controls.sc-bxf-context-menu{display:flex;margin-left:auto;align-items:center;color:#6b6a67}.bxf-context-zoom-controls__button.sc-bxf-context-menu{margin:0;border:none;padding:0;background-color:transparent}.bxf-context-zoom-controls__button.sc-bxf-context-menu:focus{outline:0.0625rem dotted var(--primary-action__color);outline:auto var(--primary-action__color)}.bxf-context-zoom-controls__button.bxf__focus--keyboard-only.sc-bxf-context-menu:focus:not(:focus-visible){outline:0}.bxf-context-zoom-controls__button.sc-bxf-context-menu:active{color:var(--icon__hover-press);color:var(--icon__hover-press)}.bxf-context-zoom-controls__button.sc-bxf-context-menu:active svg.sc-bxf-context-menu path.sc-bxf-context-menu{stroke:currentColor}.bxf-context-zoom-controls__button.sc-bxf-context-menu:active:hover,.bxf-context-zoom-controls__button.sc-bxf-context-menu:active:active{color:var(--icon__hover-press)}.bxf-context-zoom-controls__button.sc-bxf-context-menu:active svg.sc-bxf-context-menu rect.bxf-icon--svg__Rectangle.sc-bxf-context-menu{stroke:currentColor}.bxf-context-zoom-controls__button.sc-bxf-context-menu:active:hover,.bxf-context-zoom-controls__button.sc-bxf-context-menu:active:active{color:var(--icon__hover-press)}.bxf-context-zoom-controls__button--active.sc-bxf-context-menu{color:var(--icon__hover-press);color:var(--icon__hover-press)}.bxf-context-zoom-controls__button--active.sc-bxf-context-menu svg.sc-bxf-context-menu path.sc-bxf-context-menu{stroke:currentColor}.bxf-context-zoom-controls__button--active.sc-bxf-context-menu:hover,.bxf-context-zoom-controls__button--active.sc-bxf-context-menu:active{color:var(--icon__hover-press)}.bxf-context-zoom-controls__button--active.sc-bxf-context-menu svg.sc-bxf-context-menu rect.bxf-icon--svg__Rectangle.sc-bxf-context-menu{stroke:currentColor}.bxf-context-zoom-controls__button--active.sc-bxf-context-menu:hover,.bxf-context-zoom-controls__button--active.sc-bxf-context-menu:active{color:var(--icon__hover-press)}.bxf-context-zoom-controls-icon.sc-bxf-context-menu{display:flex;margin:0 8px;min-width:16px;align-items:center;height:16px;width:16px;cursor:pointer;color:#6b6a67;fill:none}";
const BxfContextMenuStyle0 = bxfContextMenuCss;

const { LEFT_TOP, RIGHT_TOP, LEFT_BOTTOM, RIGHT_BOTTOM, BOTTOM_LEFT, BOTTOM_CENTER, BOTTOM_RIGHT, TOP_LEFT, TOP_CENTER, TOP_RIGHT, } = BxfDynamicPositionEnum;
const { GROUP_SEPARATOR, DISABLED, ALERT, MENU_ITEM, MENU_LEFT_ICON, MENU_RIGHT_ICON, MENU_RIGHT_ICON_NO, FLYOUT_DATA, FLYOUT_ITEM_NOT_SELECTED, FLYOUT, CHECK, ARROW_RIGHT, SHOW, TARGET, SELECTED, ZOOM_IN, ZOOM_OUT, BOTTOM_BORDER, ZOOM_CONTROLS, INNER_LABEL, MENU_RIGHT_ICON_FLYOUT, ZOOM_CONTROLS_ICON, ZOOM_CONTROLS_BUTTON, ZOOM_CONTROLS_BUTTON_ACTIVE, MENU_ITEM_WRAPPER, ZOOM_IN_LABEL, ZOOM_OUT_LABEL, MENU_ITEM_COMPACT, } = BxfContextMenuConstants.STRING;
const { MENU_CONTAINER } = BxfPositionConstants.STRING;
const BxfContextMenu = /*@__PURE__*/ proxyCustomElement(class BxfContextMenu extends H {
    get host() { return this; }
    // #region "Private Members"
    data = [];
    _overlay;
    _parentRef;
    _targetRef;
    _sourceRef;
    _flyoutOverlaysMap = {};
    _flyoutTargetRefMap = {};
    _flyoutSourceRefMap = {};
    _keepOverlayOpen = false;
    _zoomInRefMap = {};
    _zoomOutRefMap = {};
    _hasOpened = false;
    /**
     * UUID to ensure unique flyout IDs in dom
     */
    _uid = uuidv4();
    i18n;
    // #endregion "Props"
    // #region "Events"
    /**
     * Event is emitted when an option is clicked
     */
    contextMenuRightClicked;
    /**
     * Event is emitted when an option is clicked
     */
    contextMenuItemClicked;
    /**
     * Event is emitted when zoom-in icon is clicked
     */
    zoomIn;
    /**
     * Event is emitted when zoom-out icon is clicked
     */
    zoomOut;
    /**
     * This event is emitted when Context Menu is opened
     */
    contextMenuOpened;
    /**
     * This event is emitted when Context Menu is closed
     */
    contextMenuClosed;
    // #endregion "State"
    /**
     * Watch on the propName isOpen to control if overlay is open
     * @param {boolean} newProp
     */
    isOpenHandler(newProp) {
        if (newProp) {
            this.openOverlay();
        }
        else {
            this.closeOverlay();
        }
    }
    handleTabBarEvents() {
        if (this.isOpen) {
            this.closeOverlay();
        }
    }
    constructor() {
        super();
        this.__registerHost();
        this.contextMenuRightClicked = createEvent(this, "contextMenuRightClicked", 7);
        this.contextMenuItemClicked = createEvent(this, "contextMenuItemClicked", 7);
        this.zoomIn = createEvent(this, "zoomIn", 7);
        this.zoomOut = createEvent(this, "zoomOut", 7);
        this.contextMenuOpened = createEvent(this, "contextMenuOpened", 7);
        this.contextMenuClosed = createEvent(this, "contextMenuClosed", 7);
        this.namespaceI18n = undefined;
        this.i18nKeys = undefined;
        this.specificActions = [];
        this.objectControls = [];
        this.editingControls = [];
        this.appControls = [];
        this.overridePlacement = BOTTOM_LEFT;
        this.skipDragAndDrop = false;
        this.isOpen = false;
        this.isTracking = true;
        this.trackingData = undefined;
        this.isCompact = BxfDefaultState.isCompact;
        this.parentOverlayContainerSelector = 'body';
        this.dataTestSuffix = undefined;
        this.keepMouseFocus = false;
        this.assistiveText = '';
        this.scrollToFit = true;
        this.useFocusVisible = true;
        this.isFlyoutOpenMap = {};
        this.targetRefHandler = this.targetRefHandler.bind(this);
        this.keyDownHandler = this.keyDownHandler.bind(this);
        this.zoomMouseDownHandler = this.zoomMouseDownHandler.bind(this);
        this.isOutsideOverlay = this.isOutsideOverlay.bind(this);
    }
    componentWillLoad() {
        this.data = [
            this.specificActions,
            this.objectControls,
            this.editingControls,
            this.appControls,
        ];
        if (isUsingI18n() && this.namespaceI18n) {
            this.initI18n();
        }
        this.initRovingTabIndex(this.data);
    }
    componentDidRender() {
        this.initOverlayController();
        this.updateState(this.isOpen);
    }
    disconnectedCallback() {
        this.closeOverlay();
        this.i18n?.destroyTranslations();
    }
    initI18n() {
        this.i18n = new BxfI18n(this.namespaceI18n);
        window['i18n'].on('languageChanged', () => {
            this.i18n.languageChangedHandler(this.translateText());
        });
        window['i18n'].on('loaded', () => {
            this.translateText();
        });
    }
    translateText() {
        translateKeys(this, this.i18nKeys, this.i18n);
        this.data.forEach((controlsArray) => {
            this.translateData(controlsArray);
        });
    }
    translateData(arr) {
        arr.forEach((item) => {
            translateKeys(item, item.i18nKeys, this.i18n);
            if (item.flyoutMenu) {
                this.translateData(item.flyoutMenu);
            }
        });
    }
    closeOverlay() {
        if (this._overlay) {
            this._overlay.close();
            this._overlay = null;
        }
        this.closeOpenFlyouts();
        this.contextMenuClosed.emit();
    }
    openOverlay() {
        if (this.isOpen && this._overlay) {
            this._overlay.open();
            this.contextMenuOpened.emit();
        }
    }
    /**
     * Set focus source to keyboard when pressed, and support keyboard open on Mac
     * @param {KeyboardEvent} event
     */
    keyDownHandler(event) {
        /* istanbul ignore else  */
        if (event.key === KeyboardEventKey.ContextMenu ||
            (event.key === KeyboardEventKey.F10 && event.shiftKey)) {
            this.openContextMenu(event);
        }
    }
    /**
     * Given a menu ref and a parent index, find all immediate (non-flyout) menu
     * children for that ref.
     */
    getImmediateMenuChildren(ref, index) {
        if (index) {
            return Array.from(ref.querySelectorAll(`[data-bxf-parent=${index}] .${MENU_ITEM}`));
        }
        const menuItemArray = Array.from(ref.querySelectorAll(`.${SHOW} .${MENU_ITEM}`));
        const menuItemWithParentArray = Array.from(ref.querySelectorAll(`.${SHOW}[data-bxf-parent] .${MENU_ITEM}`));
        return _.difference(menuItemArray, menuItemWithParentArray);
    }
    /**
     * Given an array of focusable children, return the index in the array
     * where the active element is
     */
    getIndexOfActiveElement(focusableChildren) {
        const activeElem = FocusTrap.getFocusedElem('document');
        return focusableChildren.findIndex((e) => activeElem === e);
    }
    /**
     * Given a menu item element and tabindex value, set the tabindex for the menu item element
     * 	and any child buttons to the given value.
     */
    setTabIndexForMenuItem(menuItem, tabIndex) {
        menuItem.tabIndex = tabIndex;
        const menuItemButtons = menuItem.querySelectorAll('button');
        /* istanbul ignore else  */
        if (menuItemButtons) {
            menuItemButtons.forEach((button) => {
                button.tabIndex = tabIndex;
            });
        }
    }
    /**
     * Move focus between menu items on Up/Down arrow key.
     * @param {KeyboardEvent} event
     * @param {HTMLElement} ref
     * @param {string} parentIndex
     */
    navKeyEventHandler(event, ref, parentIndex) {
        const focusableChildren = this.getImmediateMenuChildren(ref, parentIndex);
        const activeIndex = this.getIndexOfActiveElement(focusableChildren);
        /* istanbul ignore else  */
        if (activeIndex !== -1) {
            event.preventDefault();
            const focusIndex = FocusIndexManager.getFocusIndexForNavEvent(focusableChildren, activeIndex, event);
            this.setTabIndexForMenuItem(focusableChildren[activeIndex], -1);
            this.setTabIndexForMenuItem(focusableChildren[focusIndex], 0);
            focusableChildren[focusIndex].focus();
        }
    }
    /**
     * Handle keydown events for a given menu
     */
    menuKeyDownHandler(event, ref, parentIndex) {
        const navKeys = FocusIndexManager.VERTICAL_NAV_KEYS;
        const closeKeys = [KeyboardEventKey.ArrowLeft, KeyboardEventKey.Escape];
        if (navKeys.includes(event.key)) {
            event.stopPropagation();
            this.navKeyEventHandler(event, ref, parentIndex);
        }
        else if (closeKeys.includes(event.key)) {
            this.menuItemLeftKeyHandler(parentIndex, event);
        }
    }
    /**
     * Make the first item in a flyout menu keyboard focusable
     * @param {Array<BxfContextMenuInterface>} data
     */
    initRovingTabIndexFlyout(data) {
        /* istanbul ignore else  */
        if (!_.isEmpty(data)) {
            if (data[0] instanceof Array) {
                this.initRovingTabIndex(data);
            }
            else {
                data[0]['isFocusable'] = true;
            }
        }
    }
    /**
     * Given an array of flyout menu items, make only the first item in the menu,
     * 	and the first item in any flyout menu items, keyboard focusable
     */
    initRovingTabIndex(data) {
        if (!_.isEmpty(data) && !_.isEmpty(data[0])) {
            data[0][0].isFocusable = true;
            // context menu does not support nested flyouts yet, so only iterate through this loop once
            data.forEach((arr) => {
                arr.forEach((item) => {
                    if (item.flyoutMenu) {
                        this.initRovingTabIndexFlyout(item.flyoutMenu);
                    }
                });
            });
        }
    }
    /**
     * Given an event, open the context menu
     * @param {(MouseEvent | KeyboardEvent)} event
     */
    openContextMenu(event) {
        event.preventDefault();
        this.contextMenuRightClicked.emit({
            srcEvent: event,
        });
        this.updateState(true);
    }
    /**
     * Open context menu on right click event
     */
    rightClickHandler = (event) => {
        this.openContextMenu(event);
    };
    leftClickHandler = (event) => {
        event.preventDefault();
        /* istanbul ignore else  */
        if (event.buttons === 0) {
            return;
        }
        this._keepOverlayOpen = false;
        this.isOpen = false;
    };
    targetRefHandler(elm) {
        /* istanbul ignore else  */
        if (elm) {
            elm.addEventListener(WindowEventMap.click, this.leftClickHandler);
            elm.addEventListener(WindowEventMap.contextmenu, this.rightClickHandler);
            elm.addEventListener(WindowEventMap.keydown, this.keyDownHandler);
            this._targetRef = elm;
        }
    }
    /**
     * Check if mouse event occurred outside menu and flyout
     */
    isOutsideOverlay(event) {
        return !_.map(eventPath(event), BxfPositionConstants.STRING.CLASSNAME).find((el) => _.includes(el, SHOW));
    }
    initOverlayController() {
        if (!this._overlay &&
            this._parentRef &&
            this._targetRef &&
            this._sourceRef) {
            const options = {
                trigger: {},
                overlaysToClose: [MENU_CONTAINER],
                modifiers: {
                    padding: 4,
                    flipOrder: [
                        BOTTOM_LEFT,
                        BOTTOM_CENTER,
                        BOTTOM_RIGHT,
                        TOP_LEFT,
                        TOP_CENTER,
                        TOP_RIGHT,
                    ],
                    isContextMenuOverlay: true,
                    defaultPlacement: this.overridePlacement,
                    scrollToFit: this.scrollToFit,
                    keepMouseFocus: this.keepMouseFocus,
                    elementHeightStatus: {
                        originalElementHeight: BxfPositionConstants.STRING.INITIAL_ELEMENT_HEIGHT,
                    },
                },
                sourceElementOptions: {},
                targetElementOptions: {
                    addClassNames: [],
                },
                isChildOverlayOpenCallback: this.isFlyoutOverlayOpen.bind(this),
                shouldCloseOnMouseUp: true,
                useFocusVisible: this.useFocusVisible,
                parentContainer: getParentOverlayContainer(this.parentOverlayContainerSelector),
            };
            this._overlay = new BxfOverlayMenuController(this.host, this._parentRef, this._targetRef, this._sourceRef, this.updateState.bind(this), options, this.isOutsideOverlay);
            this._hasOpened = false;
        }
    }
    updateState(value) {
        if (value) {
            this.isOpen = true;
            if (this._overlay && !this._hasOpened) {
                this._overlay.openOverlayWithPosition();
                this.contextMenuOpened.emit();
                this._hasOpened = true;
            }
        }
        else if (!this.isFlyoutOverlayOpen()) {
            this._overlay = null;
            this.isOpen = false;
        }
    }
    isFlyoutOverlayOpen() {
        return (!_.isEmpty(_.compact(_.map(this.isFlyoutOpenMap, (v) => v))) &&
            this._keepOverlayOpen);
    }
    flyoutTargetRefHandler(el, index) {
        /* istanbul ignore else  */
        if (el) {
            this._flyoutTargetRefMap[index] = el;
            this.initFlyoutOverlayController(index);
        }
    }
    flyoutSourceRefHandler(el, index) {
        /* istanbul ignore else  */
        if (el) {
            this._flyoutSourceRefMap[index] = el;
            this.initFlyoutOverlayController(index);
        }
    }
    initFlyoutOverlayController(index) {
        if (!this._flyoutOverlaysMap[index] &&
            this._parentRef &&
            this._flyoutTargetRefMap[index] &&
            this._flyoutSourceRefMap[index]) {
            let currentFlyoutMenuDepth;
            /* istanbul ignore else  */
            if (this._flyoutSourceRefMap[index]) {
                // Splits the key on _number_number. Each occurrence of this indicates another flyout menu
                currentFlyoutMenuDepth =
                    index.match(/((_\d{1,2}){2})/gm).length;
            }
            const options = {
                trigger: BxfOverlayTriggerEnum.HOVER,
                modifiers: {
                    padding: 0,
                    flipOrder: [LEFT_TOP, RIGHT_TOP, LEFT_BOTTOM, RIGHT_BOTTOM],
                    defaultPlacement: LEFT_TOP,
                    scrollToFit: this.scrollToFit,
                    currentFlyoutMenuDepth,
                },
                sourceElementOptions: {},
                targetElementOptions: {
                    addClassNames: [],
                },
                isFlyoutMenu: true,
                keepMouseFocus: this.keepMouseFocus,
                shouldCloseOnMouseUp: true,
            };
            this._flyoutOverlaysMap[index] = new BxfOverlayMenuController(this.host, this._parentRef, this._flyoutTargetRefMap[index], this._flyoutSourceRefMap[index], this.updateFlyoutState.bind(this, index), options, this.isOutsideOverlay);
        }
    }
    /**
     * Remove item with aria-owns=<id of flyout> from DOM
     */
    removeFlyoutOwnsSibling(key) {
        const parentRef = this._flyoutTargetRefMap[key].parentElement;
        // remove flyout owner from DOM, not needed anymore
        const flyoutOwner = parentRef.querySelector(`[data-bxf-owns="${key}"]`);
        if (flyoutOwner) {
            parentRef.removeChild(flyoutOwner);
        }
    }
    /**
     * After closing a flyout menu, update the following ARIA attributes:
     *  - set aria-expanded to false
     *  - remove sibling with aria-owns=<id of flyout>, as it is no longer needed
     */
    setAriaAttrsForClosedTarget(key) {
        /* istanbul ignore else  */
        if (this._flyoutTargetRefMap[key]) {
            // NOTE: string "true" or "false" needed for aria-expanded, not boolean
            this._flyoutTargetRefMap[key].setAttribute(AriaAttr.EXPANDED, 'false');
            this.removeFlyoutOwnsSibling(key);
        }
    }
    /**
     * Add empty container with aria-owns=(id of flyout) as a sibling of target.
     * 	This will keep flyout menu an immediate sibling of parent menuitem
     * 	even when overlay controller changes DOM structure.
     *
     * Explicitly set role=presentation on container to keep container out of
     * 	accessibility tree, but keep child (via aria-owns) in tree, so tree will
     * 	look like:
     * - menu
     * 	- menuitem "Flyout parent"
     * 	- menu "Flyout parent"
     * 	  - menuitem "Flyout child"
     *
     * NOTE: we cannot set aria-owns on the parent listitem, as that will
     * 	override its role from none to listitem
     *
     * @see [WAI-ARIA authoring practices - Menu](https://www.w3.org/TR/wai-aria-practices-1.1/#wai-aria-roles-states-and-properties-13)
     */
    addFlyoutOwnsSibling(key) {
        const keyStr = key.toString();
        const flyoutOwner = document.createElement('div');
        flyoutOwner.setAttribute(AriaAttr.ROLE, Role.PRESENTATION);
        flyoutOwner.setAttribute(AriaAttr.OWNS, this.getFlyoutId(keyStr));
        // using data-bxf-owns to provide shorthand for unique ID
        flyoutOwner.dataset.bxfOwns = keyStr;
        this._flyoutTargetRefMap[key].parentElement.appendChild(flyoutOwner);
    }
    /**
     * After opening a flyout menu, update the following ARIA attributes:
     *  - set aria-expanded to true
     *  - add sibling with aria-owns=<id of flyout> (see addFlyoutOwnsSibling for
     * 		why this is needed)
     */
    setAriaAttrsForOpenTarget(key) {
        /* istanbul ignore else  */
        if (this._flyoutTargetRefMap[key]) {
            // NOTE: string "true" or "false" needed for aria-expanded, not boolean
            this._flyoutTargetRefMap[key].setAttribute(AriaAttr.EXPANDED, 'true');
            this.addFlyoutOwnsSibling(key);
        }
    }
    /**
     * Handles overlay controller
     * @param {number | string} index context menu item
     * @param {boolean} value context menu item
     * @returns {void}
     */
    updateFlyoutState(index, value) {
        if (value) {
            this.isFlyoutOpenMap[index] = true;
            /* istanbul ignore else  */
            if (this._flyoutOverlaysMap[index]) {
                this._flyoutOverlaysMap[index].openOverlayWithPosition();
            }
            this.setAriaAttrsForOpenTarget(index);
        }
        else {
            this._flyoutOverlaysMap[index] = null;
            this.initFlyoutOverlayController(index.toString());
            this.isFlyoutOpenMap[index] = false;
            this.setAriaAttrsForClosedTarget(index);
        }
    }
    /**
     * When enter key pressed, close all flyouts
     */
    closeOpenFlyouts() {
        /* istanbul ignore else  */
        if (this.isFlyoutOpenMap) {
            // find all open flyout menus
            const openIndices = _.compact(_.map(this.isFlyoutOpenMap, (v, k) => {
                if (v) {
                    return k;
                }
                return null;
            }));
            openIndices.forEach((index) => {
                if (this._flyoutOverlaysMap[index]) {
                    this._flyoutOverlaysMap[index].close();
                }
                this.updateFlyoutState(index, false);
            });
        }
    }
    /**
     * Helper function to close all context menu overlays
     */
    closeContextMenu(key) {
        this._keepOverlayOpen = false;
        if (this._flyoutOverlaysMap[key]) {
            this._flyoutOverlaysMap[key].close();
        }
        this.updateFlyoutState(key, false);
        this.closeOpenFlyouts();
        this.isOpen = false;
    }
    /**
     * Event handler for selection of context menu item
     */
    menuItemClickHandler(item, key, event) {
        if (item.isDisabled) {
            event.stopPropagation();
            this._keepOverlayOpen = true;
            return;
        }
        this.contextMenuItemClicked.emit({
            element: item,
            host: this.host,
            srcEvent: event,
        });
        this.closeContextMenu(key);
    }
    /**
     * Keyboard event handler for selection of inline menu item.
     * 	- Do not allow disabled items to be selected
     *  - If item not disabled, emit click event.
     *  - When item selected that has flyout menu, toggle flyout menu. Otherwise, close the menu.
     * @param {BxfContextMenuInterface} item
     * @param {string} key
     * @param {KeyboardEvent} event
     * @returns {void}
     */
    menuItemEnterHandler(item, key, event) {
        event.stopPropagation();
        if (item.isDisabled) {
            this._keepOverlayOpen = true;
            return;
        }
        this.contextMenuItemClicked.emit({
            element: item,
            host: this.host,
            srcEvent: event,
        });
        if (!item.flyoutMenu) {
            this.closeContextMenu(key);
        }
        else {
            this._keepOverlayOpen = true;
            this.updateFlyoutState(key, true);
            /* istanbul ignore else  */
            if (this._flyoutSourceRefMap[key]) {
                setTimeout(() => {
                    FocusTrap.focusFirstElem(this._flyoutSourceRefMap[key], false);
                });
            }
        }
    }
    /**
     * On right arrow key press, if a menu item has a flyout menu,
     *  expand the flyout menu
     */
    menuItemRightKeyHandler(item, key, event) {
        if (item.flyoutMenu) {
            event.preventDefault();
            event.stopPropagation();
            this.updateFlyoutState(key, true);
            // focus focusable item inside menu
            /* istanbul ignore else  */
            if (this._flyoutSourceRefMap[key]) {
                setTimeout(() => {
                    FocusTrap.focusFirstElem(this._flyoutSourceRefMap[key], false);
                });
            }
        }
    }
    /**
     * On left arrow key press, collapse current menu if current menu
     * 	is a flyout menu. Once menu collapsed, find element that triggered
     * 	flyout and do the following:
     * 	  - Set roving tabindex to that element
     *    - Focus that element
     */
    menuItemLeftKeyHandler(parentKey, event) {
        if (parentKey) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            /* istanbul ignore else  */
            if (this._flyoutOverlaysMap[parentKey]) {
                this._flyoutOverlaysMap[parentKey].close();
            }
            this.updateFlyoutState(parentKey, false);
            /* istanbul ignore else  */
            if (this._flyoutTargetRefMap[parentKey]) {
                setTimeout(() => {
                    this._flyoutTargetRefMap[parentKey].tabIndex = 0;
                    this._flyoutTargetRefMap[parentKey].focus();
                });
            }
        }
        else if (event.key === KeyboardEventKey.Escape) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            this._keepOverlayOpen = false;
            this.closeOverlay();
        }
    }
    /**
     * Listen to the following keyboard events on a given menu item:
     * 	- Enter - select the menu item
     * 	- Right arrow - toggle flyout menu if item has flyout
     * @param {BxfContextMenuInterface} item
     * @param {string} key
     * @param {KeyboardEvent} event
     */
    menuItemKeyDownHandler(item, key, event) {
        switch (event.key) {
            case KeyboardEventKey.Enter:
                this.menuItemEnterHandler(item, key, event);
                break;
            case KeyboardEventKey.ArrowRight:
                this.menuItemRightKeyHandler(item, key, event);
                break;
        }
    }
    /**
     * Event handler for displaying flyout on hovered item
     * @param {number} index
     *@return {void}
     */
    flyoutMouseOverHandler(index) {
        const menuItemElement = _.get(this._flyoutOverlaysMap, `[${index}].targetElement`);
        if (menuItemElement) {
            menuItemElement.classList.add(SELECTED);
        }
    }
    /**
     * Event handler for closing flyout on mouse leave
     * @param {number} index
     * @return {void}
     */
    flyoutMouseOutHandler(index) {
        const menuItemElement = _.get(this._flyoutOverlaysMap, `[${index}].targetElement`);
        if (menuItemElement) {
            menuItemElement.classList.remove(SELECTED);
        }
    }
    /**
     * Emit zoom out event upon zoom out button click
     * @param {MouseEvent} event
     * @param {BxfContextMenuInterface} item
     */
    zoomOutClickHandler(event, item) {
        event.stopPropagation();
        this._keepOverlayOpen = true;
        this.zoomOut.emit({ item, srcEvent: event });
    }
    /**
     * Emit zoom in event upon zoom in button click
     * @param {MouseEvent} event
     * @param {BxfContextMenuInterface} item
     */
    zoomInClickHandler(event, item) {
        event.stopPropagation();
        this._keepOverlayOpen = true;
        this.zoomIn.emit({ item, srcEvent: event });
    }
    /**
     * Get rid of focus outline and prevent menu from closing when button pressed via mouse
     * @param {MouseEvent} event
     */
    zoomMouseDownHandler(event) {
        event.stopPropagation();
    }
    /**
     *  Listen to the following keyboard events:
     * - Enter - activate zoom out button visually
     * - Tab - enable focus ring
     * @param {KeyboardEvent} event
     * @param {number} itemKey
     */
    zoomInKeyDownHandler(event, itemKey) {
        if (event.key === KeyboardEventKey.Enter) {
            this._zoomInRefMap[itemKey].classList.add(ZOOM_CONTROLS_BUTTON_ACTIVE);
            event.stopPropagation();
        }
    }
    /**
     * Listen to the following keyboard events:
     * - Enter - activate zoom out button visually
     * - Tab - enable focus ring
     * @param {KeyboardEvent} event
     * @param {number} itemKey
     */
    zoomOutKeyDownHandler(event, itemKey) {
        if (event.key === KeyboardEventKey.Enter) {
            this._zoomOutRefMap[itemKey].classList.add(ZOOM_CONTROLS_BUTTON_ACTIVE);
            event.stopPropagation();
        }
    }
    /**
     * When enter key released, remove active styling from zoom in button
     * @param {KeyboardEvent} event
     * @param {number} itemKey
     */
    zoomInKeyUpHandler(event, itemKey) {
        if (event.key === KeyboardEventKey.Enter) {
            this._zoomInRefMap[itemKey].classList.remove(ZOOM_CONTROLS_BUTTON_ACTIVE);
        }
    }
    /**
     * When enter key released, remove active styling from zoom out button
     * @param {KeyboardEvent} event
     * @param {number} itemKey
     */
    zoomOutKeyUpHandler(event, itemKey) {
        if (event.key === KeyboardEventKey.Enter) {
            this._zoomOutRefMap[itemKey].classList.remove(ZOOM_CONTROLS_BUTTON_ACTIVE);
        }
    }
    /**
     * Styling for zoom out button
     *
     */
    get zoomCss() {
        return getKeyboardFocusCSS(`${ZOOM_CONTROLS_BUTTON}`, this.keepMouseFocus);
    }
    /**
     * Render icon button for zoom out control
     */
    renderZoomOutButton(item, itemKey) {
        return (h("button", { ref: (el) => this.zoomOutRefHandler(el, itemKey), "aria-label": ZOOM_OUT_LABEL, class: this.zoomCss, onClick: (event) => this.zoomOutClickHandler(event, item), onMouseDown: this.zoomMouseDownHandler, onKeyDown: (event) => {
                this.zoomOutKeyDownHandler(event, itemKey);
            }, onKeyUp: (event) => {
                this.zoomOutKeyUpHandler(event, itemKey);
            }, tabIndex: -1 }, h("bxf-icon", { class: ZOOM_CONTROLS_ICON, type: ZOOM_OUT, state: 'secondary', isDisabled: item.isDisabled, dataTestSuffix: createSelector('00', this.dataTestSuffix, true) })));
    }
    /**
     * Store reference to zoom in button for a given item key
     * @param {HTMLElement} el
     * @param {number} index
     */
    zoomInRefHandler(el, index) {
        /* istanbul ignore else  */
        if (el) {
            this._zoomInRefMap[index] = el;
        }
    }
    /**
     * Store reference to zoom out button for a given item key
     * @param {HTMLElement} el
     * @param {number} index
     */
    zoomOutRefHandler(el, index) {
        /* istanbul ignore else  */
        if (el) {
            this._zoomOutRefMap[index] = el;
        }
    }
    /**
     * Render zoom in icon button
     */
    renderZoomInButton(item, itemKey) {
        return (h("button", { ref: (el) => this.zoomInRefHandler(el, itemKey), "aria-label": ZOOM_IN_LABEL, class: this.zoomCss, onClick: (event) => this.zoomInClickHandler(event, item), onMouseDown: this.zoomMouseDownHandler, onKeyDown: (event) => {
                this.zoomInKeyDownHandler(event, itemKey);
            }, onKeyUp: (event) => {
                this.zoomInKeyUpHandler(event, itemKey);
            }, tabIndex: -1 }, h("bxf-icon", { class: ZOOM_CONTROLS_ICON, type: ZOOM_IN, state: 'secondary', isDisabled: item.isDisabled, dataTestSuffix: createSelector('01', this.dataTestSuffix, true) })));
    }
    /**
     * Private method which is called when zoom in is clicked
     * @param {BxfContextMenuInterface} item
     * @param {BxfIconType} iconType
     */
    zoomControlsHandler(item, itemKey, iconType) {
        if (iconType === ZOOM_OUT) {
            return this.renderZoomOutButton(item, itemKey);
        }
        if (iconType === ZOOM_IN) {
            return this.renderZoomInButton(item, itemKey);
        }
        return null;
    }
    /**
     * Renders the flyout icon displayed to the right of the item
     * @param {BxfContextMenuInterface} item flyout menu item
     */
    handleFlyOutIcon(item) {
        return (h("div", { class: MENU_RIGHT_ICON }, h("bxf-icon", { type: ARROW_RIGHT, state: 'primary', isDisabled: item.isDisabled, dataTestSuffix: createSelector('02', this.dataTestSuffix, true) })));
    }
    /**
     * Renders left icons for context menu items
     * @param {BxfContextMenuInterface} item context menu item
     */
    renderLeftIcon(item) {
        if (item.isSelected) {
            return (h("div", { class: MENU_LEFT_ICON }, h("bxf-icon", { type: CHECK, state: 'primary', isDisabled: item.isDisabled, dataTestSuffix: createSelector('03', this.dataTestSuffix, true) })));
        }
        return h("div", { class: MENU_LEFT_ICON });
    }
    /**
     * Renders right icon for context menu item and flyout menu
     * @param {BxfContextMenuInterface} item context menu item
     * @param {number} itemKey
     */
    renderRightIcon(item, itemKey) {
        if (item.flyoutMenu && item.innerLabel) {
            return (h("div", { class: MENU_RIGHT_ICON_FLYOUT }, item.innerLabel, this.handleFlyOutIcon(item)));
        }
        if (item.innerLabel && item.hasZoomingControls) {
            return (h("div", { class: ZOOM_CONTROLS }, this.zoomControlsHandler(item, itemKey, ZOOM_OUT), item.innerLabel, this.zoomControlsHandler(item, itemKey, ZOOM_IN)));
        }
        if (item.flyoutMenu) {
            return this.handleFlyOutIcon(item);
        }
        if (item.innerLabel) {
            return h("div", { class: INNER_LABEL }, item.innerLabel);
        }
        return h("div", { class: MENU_RIGHT_ICON_NO });
    }
    /**
     * Renders left icon for flyout menu item
     * @param {BxfContextMenuInterface} item context menu item
     * @param {BxfContextMenuInterface} selectedItems array of items
     */
    renderFlyoutSelectedIcon(item, selectedItems) {
        if (selectedItems.length > 0) {
            return this.renderLeftIcon(item);
        }
        return h("div", { class: FLYOUT_ITEM_NOT_SELECTED });
    }
    /**
     * Adds class to item depending on its state
     * @param {BxfContextMenuInterface} item context menu item
     * @returns {string}
     */
    itemCss(item) {
        const isDisabled = item.isDisabled ? DISABLED : '';
        const hasAlert = item.hasAlert ? ALERT : '';
        const hasBottomBorder = item.hasBottomBorder ? BOTTOM_BORDER : '';
        const menuCss = this.isCompact ? MENU_ITEM_COMPACT : '';
        return getKeyboardFocusCSS(`${MENU_ITEM} ${menuCss} ${isDisabled} ${hasAlert} ${hasBottomBorder}`, this.keepMouseFocus);
    }
    /**
     * Handles if there is an Element
     * @param {HTMLElement} el items to get reference to the element
     * @param {BxfContextMenuInterface} flyoutItem items to be rendered in the menu
     * @param {string} key items to get reference to the element
     */
    flyoutHandler(el, flyoutItem, key) {
        if (el && flyoutItem.flyoutMenu) {
            return this.flyoutTargetRefHandler(el, key);
        }
        return null;
    }
    /**
     * Renders the flyout menu
     * @param {Array<BxfContextMenuInterface>} menu items to be rendered in the menu
     * @param {string} parentKey items to get reference to the element
     */
    renderFlyoutMenu(menu, parentKey) {
        /* istanbul ignore else  */
        if (!_.isEmpty(menu)) {
            const hasSelectedItems = menu.filter((item) => item.isSelected === true);
            return _.map(menu, (flyoutItem, itemKey) => this.renderContextMenuItem(flyoutItem, itemKey, parentKey, false, this.renderFlyoutSelectedIcon(flyoutItem, hasSelectedItems)));
        }
        return null;
    }
    /**
     * Generate unique ID for flyout menu
     */
    getFlyoutId(key) {
        return `flyout_${this._uid}${key}`;
    }
    /**
     * Renders the flyoutContainer menu when hovered on item with arrow right
     * @param {BxfContextMenuInterface} flyoutData context menu item
     * @param {string} index context menu item
     */
    renderFlyoutContainer(flyoutData, index) {
        const flyoutMenuData = _.get(flyoutData, FLYOUT_DATA);
        if (!_.isEmpty(flyoutMenuData)) {
            return (h("ul", { ref: (el) => this.flyoutSourceRefHandler(el, index), id: this.getFlyoutId(index), class: getKeyboardFocusCSS(`${SHOW} ${FLYOUT}`, this.keepMouseFocus), onMouseOver: this.flyoutMouseOverHandler.bind(this, index), onMouseOut: this.flyoutMouseOutHandler.bind(this, index), onKeyDown: (ev) => {
                    this.menuKeyDownHandler(ev, this._flyoutSourceRefMap[index], index);
                }, role: Role.MENU, "aria-label": this.getLabelForMenuItem(flyoutData), "data-bxf-parent": index }, this.renderFlyoutMenu(flyoutMenuData, index)));
        }
        return null;
    }
    /**
     * @param {BxfContextMenuInterface} item
     * @returns {string}
     */
    getLabelForMenuItem(item) {
        const innerLabel = ` ${item.innerLabel}`;
        return `${item.label}${item.innerLabel ? innerLabel : ''}`;
    }
    /**
     * Render a context menu item
     * @param {BxfContextMenuInterface} item
     * @param {number} itemKey
     * @param {string} parentKey
     * @param {boolean} shouldRenderFlyout
     * @param {JSX.Element} leftIconElem
     */
    renderContextMenuItem(item, itemKey, parentKey, shouldRenderFlyout, leftIconElem) {
        const key = `${parentKey}_${itemKey}`;
        return (h("li", { role: Role.NONE, class: MENU_ITEM_WRAPPER }, h("div", { ref: (el) => this.flyoutHandler(el, item, key), class: this.itemCss(item), onClick: (event) => this.menuItemClickHandler(item, key, event), onKeyDown: (event) => {
                this.menuItemKeyDownHandler(item, key, event);
            }, role: Role.MENUITEM, "aria-label": this.getLabelForMenuItem(item), "aria-disabled": item.isDisabled ? 'true' : null, "aria-haspopup": shouldRenderFlyout && item.flyoutMenu ? 'true' : null, "aria-expanded": shouldRenderFlyout && item.flyoutMenu ? 'false' : null, tabIndex: item.isFocusable ? 0 : -1, "data-bxf-key": key }, leftIconElem, item.label, this.renderRightIcon(item, itemKey)), shouldRenderFlyout && this.renderFlyoutContainer(item, key)));
    }
    /**
     * Renders the context menu groups
     * @param {Array<BxfContextMenuInterface>} menuGroup items to be rendered in the menu group
     * @param {string} parentKey items to get reference to the element
     */
    renderContextMenuGroup(menuGroup, parentKey) {
        /* istanbul ignore else  */
        if (!_.isEmpty(menuGroup)) {
            return _.map(menuGroup, (item, itemKey) => this.renderContextMenuItem(item, itemKey, parentKey, true, this.renderLeftIcon(item)));
        }
        return null;
    }
    /**
     * Starting point for rendering context menu container
     * @param {Array<Array<BxfContextMenuInterface>>} menu items to be rendered in the menu
     * @param {string} parentKey items to get reference to the element
     */
    renderContextMenuContainer(menu, parentKey) {
        return _.map(menu, (menuGroup, itemKey) => {
            if (!_.isEmpty(menuGroup)) {
                const isLastItemOfMenu = itemKey === menu.length - 1;
                const borderBottomElement = isLastItemOfMenu ? null : (h("li", { class: GROUP_SEPARATOR, role: Role.SEPARATOR }));
                const key = `${parentKey}_${itemKey}`;
                return [
                    this.renderContextMenuGroup(menuGroup, key),
                    borderBottomElement,
                ];
            }
            return null;
        }).filter(Boolean);
    }
    render() {
        return (h("div", { key: 'fcf428c9a6cefa442f50141aa86575aaa9a9bb5d', ref: (el) => {
                this._parentRef = el;
            }, "data-test": createSelector(this.host.tagName, this.dataTestSuffix) }, h("div", { key: '62bae6436614202b060d9534a5e4212d51624a27', ref: this.targetRefHandler, role: Role.PRESENTATION }, h("slot", { key: '659c82dd4fb9d5a07bcf97ebfe6fdf7b905d8133', name: TARGET, "skip-drag-and-drop": String(this.skipDragAndDrop) })), h("ul", { key: '9b0fd007eb9fc04cfffc509a0d276b23d77f62a1', class: getKeyboardFocusCSS(SHOW, this.keepMouseFocus), ref: (el) => {
                this._sourceRef = el;
            }, "aria-label": this.assistiveText, role: Role.MENU, onKeyDown: (ev) => {
                this.menuKeyDownHandler(ev, this._sourceRef, '');
            } }, this.renderContextMenuContainer(this.data, ''))));
    }
    static get watchers() { return {
        "isOpen": ["isOpenHandler"]
    }; }
    static get style() { return BxfContextMenuStyle0; }
}, [6, "bxf-context-menu", {
        "namespaceI18n": [1, "namespace-i-1-8n"],
        "i18nKeys": [16],
        "specificActions": [16],
        "objectControls": [16],
        "editingControls": [16],
        "appControls": [16],
        "overridePlacement": [513, "override-placement"],
        "skipDragAndDrop": [4, "skip-drag-and-drop"],
        "isOpen": [1540, "is-open"],
        "isTracking": [4, "is-tracking"],
        "trackingData": [16],
        "isCompact": [4, "is-compact"],
        "parentOverlayContainerSelector": [513, "parent-overlay-container-selector"],
        "dataTestSuffix": [8, "data-test-suffix"],
        "keepMouseFocus": [4, "keep-mouse-focus"],
        "assistiveText": [1, "assistive-text"],
        "scrollToFit": [516, "scroll-to-fit"],
        "useFocusVisible": [4, "use-focus-visible"],
        "isFlyoutOpenMap": [32]
    }, [[8, "tabBarItemSelected", "handleTabBarEvents"], [8, "tabBarItemAdded", "handleTabBarEvents"], [8, "tabBarItemDeleted", "handleTabBarEvents"], [8, "tabBarItemRenamed", "handleTabBarEvents"], [8, "tabBarItemDragged", "handleTabBarEvents"], [8, "tabBarItemPinned", "handleTabBarEvents"]], {
        "isOpen": ["isOpenHandler"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bxf-context-menu", "bxf-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "bxf-context-menu":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BxfContextMenu);
            }
            break;
        case "bxf-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { BxfContextMenu as B, defineCustomElement as d };
